import { message, notification } from 'antd'
import { generateMessageError } from 'modules/core/utils'
import i18n from 'i18next'

export const onCreate = ({
  form,
  setIsLoading,
  createForecastInstance,
  onRefetch,
  onclose,
  setShowAlert = null,
  sendUserDataToGTM,
}) => {
  form.validateFields().then((values) => {
    setIsLoading(true)
    setShowAlert &&
      setShowAlert((prevState) => {
        return { ...prevState, create: true }
      })
    createForecastInstance(values)
      .then(() => {
        onRefetch()
        message.success(i18n.t('FEEDBACK_CREATE_SUCCESS'), 8)
        onclose()
        setShowAlert &&
          setShowAlert((prevState) => {
            return { ...prevState, create: false }
          })
        sendUserDataToGTM()
      })
      .catch((error) => {
        notification.error({
          message: i18n.t('FEEDBACK_DEFAULT_ERROR'),
          description: generateMessageError(error, 'FEEDBACK_CREATION_FAIL'),
          duration: 0,
        })
        onclose()
        setShowAlert &&
          setShowAlert((prevState) => {
            return { ...prevState, create: false }
          })
      })
  })
}
